module.exports = __webpack_public_path__ + "static/ac_header-616318d7f1ed1ac9c7320f56799a3fcc.png";